import React from 'react'

import { ProgressBar, CloseButton } from 'react-bootstrap';

import { SyncOutlined, CheckSquareFilled } from '@ant-design/icons';

import styles from './ProgressBarItem.module.scss'

interface ProgressBarItemProps {
  fileName: string;
  fileSize: number;
  progress: number;
  onClose: () => void;
}

const ProgressBarItem = ({ fileName, fileSize, progress, onClose }: ProgressBarItemProps) => {
  const bytesToMB = (bytes: number): number => {
    return parseFloat((bytes / 1024 / 1024).toFixed(2));
  }
  return (
    <div className={styles.container}>
      <CloseButton onClick={onClose} className={styles.cancelUploadButton} />
      <div className={styles.iconContainer}>
        {progress === 100 ? <CheckSquareFilled className={styles.check} /> : <SyncOutlined style={{ fontSize: 22 }} spin />}
      </div>
      <div className={styles.textContainer}>
        <span className={styles.fileNameText}>{fileName}</span>
        <span className={styles.fileSizeText}>{bytesToMB(fileSize)}MB</span>
        <div className={styles.progressWrapper}>
          <ProgressBar animated now={progress} /> 
          <span style={{ paddingLeft: 5, fontSize: 12 }}>{progress}%</span>
        </div>
      </div>
    </div>
  )
}

export default ProgressBarItem
